import WidgetContainer from 'components/Widget/WidgetContainer'
import WidgetPresentation from 'components/Widget/WidgetPresentation'
import WidgetData from 'components/Widget/WidgetData'

export default {
  Container: WidgetContainer,
  Presentation: WidgetPresentation,
  Data: WidgetData,
}
